import { ChangeDetectionStrategy, Component, OnDestroy, signal } from '@angular/core';
import { CurrentUserService } from '@core/services';
import { environment } from '@environments/environment';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '@shared-features/buttons/button/button.component';
import { UserAccount } from '@shared/interfaces';
import { DividerModule } from 'primeng/divider';
import { Subscription } from 'rxjs';
import { MessageComponent } from '../message/message.component';
import { ModalComponent } from '../modal/modal.component';

@Component({
    selector: 'account-info-verification-modal',
    standalone: true,
    imports: [ModalComponent, TranslateModule, ButtonComponent, DividerModule, MessageComponent, ButtonComponent],
    templateUrl: './account-info-verification.component.html',
    styleUrl: './account-info-verification.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountInfoVerificationComponent implements OnDestroy {
    impersonatedUser: UserAccount | null = this.currentUserService.getImpersonatedUser();
    isDefaultAddressMissing = signal(false);
    isLaboratoryMissing = signal(false);
    isModalVisible = signal(false);

    private readonly subscription: Subscription = new Subscription();
    readonly accountUrl = environment.accountsUrl + '/Account/AccountDetail';

    constructor(private currentUserService: CurrentUserService) {
        this.subscription.add(
            this.currentUserService.currentUser$.subscribe(currentUser => {
                this.isLaboratoryMissing.set(!currentUser.laboratoryName);
                this.isDefaultAddressMissing.set(
                    !currentUser.hasDefaultBillingAddress || !currentUser.hasDefaultShippingAddress
                );
                this.isModalVisible.set(this.isLaboratoryMissing() || this.isDefaultAddressMissing());
            })
        );
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    refreshPage() {
        location.reload();
    }

    closeModal() {
        this.isModalVisible.set(false);
    }

    signOut() {
        this.currentUserService.logout();
    }

    stopImpersonation() {
        this.currentUserService.removeUserToImpersonate();
    }
}
